module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "href": "#/toc01#chap_08",
      "id": "chap08"
    }
  }, [_vm._v("HOW ARE DREAMS MADE?")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterAuthor"
  }, [_vm._v("Alain de Botton")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("philosopher")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Most of the time, you feel in charge of your own mind. You want to play with some Lego? Your brain is there to make it happen. You fancy reading a book? You can put the letters together and watch characters emerge in your imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But at night, strange stuff happens. While you’re in bed, your mind puts on the weirdest, most amazing and sometimes scariest shows.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("You might be swimming the Amazon River, hanging on to the wing of a plane, sitting down for a five-hour exam with your worst teacher or eating a pile of worms. Things that you know from real life, and perhaps haven’t even paid much attention to, have a habit of cropping up in dreams in full Technicolor: the man who runs the newsagent suddenly has a starring role in a holiday you’re dreaming of having taken in Zanzibar. A boy at school you never speak to turns out to be your best friend in a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the olden days, people believed that our dreams were full of clues about the future. Nowadays, we tend to think that dreams are a way for the mind to rearrange and tidy itself up after the activities of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Why are dreams sometimes scary? During the day, things may happen that frighten us, but we are so busy we don’t have time to think properly about them. At night, while we are sleeping safely, we can give those fears a run around. Or maybe something you did during the day was lovely but you were in a hurry and didn’t give it time. It may pop up in a dream. In dreams, you go back over things you missed, repair what got damaged, make up stories about what you’d love, and explore the fears you normally put to the back of your mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dreams are both more exciting and more frightening than daily life. They’re a sign that our brains are marvellous machines – and that they have powers we don’t often give them credit for, when we’re just using them to do our homework or play a computer game. Dreams show us that we’re not quite the bosses of our own selves.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/12_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fda4af1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap08.vue
// module id = 93
// module chunks = 0